import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent implements OnInit {
  @Input() title: string;
  @Input() placement?: 'right' | 'left' | 'top' | 'bottom' = 'right';
  @Input() delay = 200;

  constructor() {}

  ngOnInit() {}
}
// enum for placement
// delay property is optional and pass default delay
